import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataSpecs } from '@/features/equipments/types/equipmentModelLatestFipe'

interface FipeTechnicalSpecificationsAccordionProps {
  specsData?: EquipmentModelLatestFipeDataSpecs
}

export default function FipeTechnicalSpecificationsAccordion({ 
  specsData 
}: FipeTechnicalSpecificationsAccordionProps) {
  return (
    <Accordion
      name="TechnicalSpecifications"
      head="Ficha Técnica"
      defaultOpen
      body={
        <div className="flex flex-col gap-1">
          <div className='flex items-center gap-1'>
            <InfoField label="Propulsão" value={specsData?.Propulsao} />
            <InfoField label="Combustível" value={specsData?.Combustivel} />
            <InfoField label="Valor do Seguro" value={specsData?.["Valor Seguro"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Procedência" value={specsData?.Procedencia} />
            <InfoField label="Garantia" value={specsData?.Garantia} />
            <InfoField label="Configuração" value={specsData?.Configuracao} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Porte" value={specsData?.Porte} />
            <InfoField label="Lugares" value={specsData?.Lugares} />
            <InfoField label="Portas" value={specsData?.Portas} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Plataforma" value={specsData?.Plataforma} />
            <InfoField label="Série" value={specsData?.Serie} />
            <InfoField label="Geração" value={specsData?.Geracao} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Potência" value={specsData?.Potencia} />
            <InfoField label="Torque" value={specsData?.Torque} />
          </div>
        </div>
      }
    />
  )
}